var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7364 16.3445H0.26362C0.117924 16.3445 0 16.2264 0 16.0808V0.26362C0 0.118042 0.117924 0 0.26362 0H8.31413C8.38404 0 8.45112 0.0277744 8.50055 0.0772031C8.54998 0.126632 8.57775 0.193714 8.57775 0.26362V3.42224H11.7364C11.8063 3.42224 11.8734 3.45002 11.9228 3.49945C11.9722 3.54888 12 3.61596 12 3.68586V16.0808C12 16.1507 11.9722 16.2178 11.9228 16.2673C11.8734 16.3167 11.8063 16.3445 11.7364 16.3445ZM0.527241 15.8172H11.4728V3.94949H8.31413C8.16856 3.94949 8.05051 3.83144 8.05051 3.68586V0.527241H0.527241V15.8172Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7363 3.94949C11.6664 3.94961 11.5993 3.92183 11.55 3.87217L8.12773 0.449926C8.02781 0.346478 8.02923 0.18207 8.13091 0.0803756C8.23259 -0.0213186 8.397 -0.0228371 8.50046 0.0770802L11.9227 3.49932C11.9981 3.57476 12.0206 3.6881 11.9798 3.7866C11.9391 3.88511 11.8429 3.94925 11.7363 3.94936L11.7363 3.94949Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8016 13.9453H2.19819C2.05261 13.9453 1.93457 13.8273 1.93457 13.6817C1.93457 13.5361 2.05261 13.4181 2.19819 13.4181H9.8016C9.94718 13.4181 10.0652 13.5361 10.0652 13.6817C10.0652 13.8273 9.94718 13.9453 9.8016 13.9453Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8016 11.3357H2.19819C2.05261 11.3357 1.93457 11.2176 1.93457 11.072C1.93457 10.9265 2.05261 10.8084 2.19819 10.8084H9.8016C9.94718 10.8084 10.0652 10.9265 10.0652 11.072C10.0652 11.2176 9.94718 11.3357 9.8016 11.3357Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8016 8.72597H2.19819C2.05261 8.72597 1.93457 8.60793 1.93457 8.46235C1.93457 8.31677 2.05261 8.19873 2.19819 8.19873H9.8016C9.94718 8.19873 10.0652 8.31677 10.0652 8.46235C10.0652 8.60793 9.94718 8.72597 9.8016 8.72597Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.a12012809df909a1932e31714dd77a8f.svg";
export { ForwardRef as ReactComponent };